// @flow @format
import React, {PureComponent} from 'react';
import VirtualizedSelect from 'react-virtualized-select';
import createFilterOptions from 'react-select-fast-filter-options';

const LABEL_KEY = 'label';
const VALUE_KEY = 'value';

class Select extends PureComponent<{
	options: any,
}> {
	render() {
		return (
			<VirtualizedSelect
				{...this.props}
				options={this.props.options}
				filterOptions={createFilterOptions({
					labelKey: LABEL_KEY,
					valueKey: VALUE_KEY,
					indexes: [LABEL_KEY, VALUE_KEY],
					options: this.props.options,
				})}
			/>
		);
	}
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/Select.js